import baseService from "./baseService";
import { store } from "../Redux/store";

export const getUserTimeEntries = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.userId) queryParams.append('userId', params.userId);
    
    const query = queryParams.toString() ? `?${queryParams.toString()}` : '';
    const response = await baseService.get(`/time-entries${query}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getUserTimeEntriesByUserId = async (userId, params = {}) => {
  try {
    const response = await baseService.get(`/time-entries/user/${userId}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const getUserTimeEntriesById = async (id) => {
  try {
    const response = await baseService.get(`/time-entries/get-entry/${id}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const createTimeEntry = async (timeEntryData) => {
  try {
    const response = await baseService.post('/time-entries', timeEntryData);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const updateTimeEntry = async (id, timeEntryData) => {
  try {
    const response = await baseService.put(`/time-entries/${id}`, timeEntryData);
    return response?.data;
  } catch (error) {
    return error;
  }
};


export const deleteTimeEntry = async (id) => {
  try {
    const response = await baseService.delete(`/time-entries/${id}`);
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const approveTimeEntries = async (timeEntryIds) => {
  try {
    const response = await baseService.post('/time-entries/approve', { timeEntryIds });
    return response?.data;
  } catch (error) {
    return error;
  }
};

export default {
  getUserTimeEntries,
  createTimeEntry,
  updateTimeEntry,
  deleteTimeEntry,
  approveTimeEntries
};